import { Component, OnInit } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { AppSignalRService } from './services/app-signalr.service';
import { LogService } from './services/log.service';
import { BUILDDATE } from '../build';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent implements OnInit {
  
  receivedMessage: string = '';
  
  constructor(private signalRService: AppSignalRService, private logger: LogService) {}

  ngOnInit(): void {
    const buildMode = environment.production ? 'production (--prod)' : 'development (--debug)';
    this.logger.log('AppComponent ngOnInit, builddate =  ' + BUILDDATE + ", buildMode = " + buildMode + ", url = " + window.location.href + ", so = " + window.matchMedia('(display-mode: standalone)').matches + ", sw = " + ('serviceWorker' in navigator));
    this.signalRService.startConnection().subscribe(() => {
      console.log('AppComponent ngOnInit: SignalR connection established');
    });
  }

  sendMessage(message: string): void {
    this.signalRService.sendMessage(message);
  }  
  
}
